import styles from "./BurgerMenu.module.css";

export default function BurgerMenu({ isOpen, toggleMenu, light = false }) {
  return (
    <svg
      className={`${styles.vbpHeaderMenuButtonSvg} ${
        light ? styles.strokeLight : ""
      } ${isOpen ? styles.menuOpen : ""}`}
      onClick={toggleMenu}
      viewBox="0 0 100 100"
      width="30"
      height="30"
      aria-label="Toggle menu"
    >
      <line
        x1="0"
        y1="35"
        x2="100"
        y2="35"
        className={styles.top}
        shapeRendering="crispEdges"
      />
      <line
        x1="0"
        y1="50"
        x2="100"
        y2="50"
        className={styles.middle}
        shapeRendering="crispEdges"
      />
      <line
        x1="0"
        y1="65"
        x2="100"
        y2="65"
        className={styles.bottom}
        shapeRendering="crispEdges"
      />
    </svg>
  );
}
